import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react'
import { AiFillStar } from 'react-icons/ai'

const FilterRating = (props) => {

    const rate = props.rated;
  return (
    <>
        <div className="rating d-flex ">
           
                <div>
                    <AiFillStar className={`${rate >= 2 ? '': 'color'}`} />
                </div>
                <div>
                    <AiFillStar className={`${rate >= 4 ? '': 'color'}`}  />
                </div>
                <div>
                    <AiFillStar className={`${rate >= 6 ? '': 'color'}`}  />
                </div>
                <div>
                    <AiFillStar className={`${rate >= 8 ? '': 'color'}`}  />
                </div>
                <div>
                    <AiFillStar className={`cursor-pointer ${rate >= 10 ? '': 'color'}`}  />
                </div>
                

            

        </div>
    </>
  )
}

export default FilterRating